import { render, staticRenderFns } from "./additional-info.vue?vue&type=template&id=1a314ead&"
import script from "./additional-info.vue?vue&type=script&lang=js&"
export * from "./additional-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports